import Vue from 'vue'
import segment from '@/plugins/segment'

Vue.use(segment, {
    writekey: process.env.VUE_APP_SEGMENT_WRITEKEY || ''
})
  